import * as fromDatatype from "../datatype-library";

export interface bl_fm_file_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    drive_guid: fromDatatype.GuidDataFieldInterface;
    url_key: fromDatatype.VarcharDatatypeInterface;
    app_file_item_guid: fromDatatype.GuidDataFieldInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    file_size: fromDatatype.VarcharDatatypeInterface;
    extension: fromDatatype.VarcharDatatypeInterface;
    mime_type: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
  sort_order: fromDatatype.BigIntegerDatatypeInterface;
}


export class bl_fm_file_hdr_RowClass
    implements bl_fm_file_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    drive_guid: fromDatatype.GuidDataFieldInterface;
    url_key: fromDatatype.VarcharDatatypeInterface;
    app_file_item_guid: fromDatatype.GuidDataFieldInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    file_size: fromDatatype.VarcharDatatypeInterface;
    extension: fromDatatype.VarcharDatatypeInterface;
    mime_type: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
  sort_order: fromDatatype.BigIntegerDatatypeInterface;
}
